import { cn } from '@/lib/helpers/utils';
import React from 'react';
export const SectionTitle = ({ children, textColorClasses = 'text-gray', componentClasses, large = false }: any) => {
  return (
    <h2
      className={cn(
        'max-w-4xl',
        large
          ? 'display-title-semibold display-title-3xl md:display-title-5xl'
          : 'display-title-semibold display-title-2xl md:display-title-3xl',
        textColorClasses,
        componentClasses ?? ''
      )}
    >
      {children}
    </h2>
  );
};

export const SectionStrapline = ({ children, textColorClasses = 'text-secondary-1100', componentClasses }: any) => (
  <p
    className={cn(
      'uppercase tracking-widest text-sm font-semibold leading-5',
      textColorClasses,
      componentClasses ?? ''
    )}
  >
    {children}
  </p>
);

export const SectionParagraph = ({ children, componentClasses }: any) => (
  <div className={cn('font-medium text-lg flex justify-center leading-7 max-w-4xl', componentClasses ?? '')}>
    {children}
  </div>
);
